import { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { STATUS, STREAMING_ENDPOINT } from 'constants';
import { UserSettingsContext } from 'contexts/UserSettingsContext';

export function useSSE(eventName, task, isActive) {
    const workerRef = useRef(null);
    const [sseSuccess, setSseSuccess] = useState(null);
    const [sseError, setSseError] = useState(null);
    const setSseSuccessRef = useRef(setSseSuccess);
    const setSseErrorRef = useRef(setSseError);
    const { tenant } = useContext(UserSettingsContext);

    useEffect(() => {
        setSseSuccessRef.current = setSseSuccess;
        setSseErrorRef.current = setSseError;
    }, []);

    const handleEvent = useCallback((eventData) => {
        try {
            //console.log('sse event', eventData, eventData.data.event_name, eventName)
            if (eventData.data.event_name === eventName && (!task || eventData.data?.task === task)) {
                console.log("Event received from server", eventData, eventName, task)
                if(eventData.data.result && typeof eventData.data.status === 'string'){
                    console.log("has result", eventData.data.status, eventData.data.result)
                    if(eventData.data.status === STATUS.SUCCESS){
                        setSseSuccessRef.current(eventData.data.result);
                        setSseErrorRef.current(null);
                    }
                }
                if(eventData.data.status === STATUS.ERROR){
                    setSseErrorRef.current({id: eventData.data.id, message: eventData.data.result});
                    console.error('SSE error: ', eventData.data);
                }
            }
        } catch (error) {
            console.error('Error processing SSE event:', error);
            setSseError({ message: 'Error processing event from server' });
        }
    }, [task, eventName]);

    useEffect(() => {
        if (!isActive || typeof SharedWorker === 'undefined' || !tenant?.id) return;

        if(workerRef.current === null){
            try {
                workerRef.current = new SharedWorker('/sharedWorker.js');
            } catch (error) {
                console.error('Error creating SharedWorker:', error);
                setSseError({ message: 'Failed to create SharedWorker' });
            }
            //console.log('useSSE: SharedWorker instantiated:', workerRef.current);

            const handleWorkerMessage = (event) => {
                try {
                    handleEvent(event.data);
                } catch (error) {
                    console.error('Error parsing SSE event data:', error);
                }
            };

            workerRef.current.port.onmessage = handleWorkerMessage;

            //console.log('useSSE: Sending connect message to shared worker', workerRef.current.port );
            workerRef.current.port.postMessage({ type: 'connect', endpoint: STREAMING_ENDPOINT, eventName: `${eventName}_${tenant.id}` });
        }

        return () => {
            if (workerRef.current && workerRef.current.port) {
                workerRef.current.port.postMessage({ type: 'disconnect' });
                workerRef.current = null;
            }
        };
    }, [isActive, handleEvent, eventName, tenant]);

    return {sseSuccess, setSseSuccess, sseError, setSseError}
};

export default useSSE;